import React from 'react';
import RetentionReport from 'components/rentention';

function RententionReportPage() {
  return <RetentionReport />;
}

export default RententionReportPage;
